<template>
  <slot :submitting="submitting" :success="success" :submissionErrors="submissionErrors" :submittable="submittable"
    :onSubmit="onSubmit" :onExpired="onExpired" :country="country" :token="token" :setCaptchaRef="setCaptchaRef"
    :values="values" :onFieldChange="onFieldChange" :setFormRef="setFormRef">
  </slot>
</template>

<script>
export default {
  data() {
    return {
      formData: null,
      submitting: false,
      captchaRef: null,
      token: {
        value: ''
      },
      response: {
        success: false,
        errors: {}
      },
      country: {
        value: null,
      },
      values: {}
    }
  },

  computed: {
    success() {
      return this.response['success'] || false
    },

    submissionErrors() {
      if (this.response['success'] == false) {
        return this.normalizeErrors(this.response['errors'])
      }

      return {};
    },

    submittable() {
      return !this.submitting && this.token && this.token.value
    }
  },

  methods: {
    normalizeErrors(errors) {
      if (!errors) {
        return {}
      }

      if (Array.isArray(errors)) {
        return {
          form: errors
        }
      }

      return errors
    },

    setFieldValue(name, value) {
      const match = /^fields\[(.+)\]$/.exec(name || '')

      if (match) {
        this.values[match[1]] = String(value).trim()
      }
    },

    onFieldChange(event) {
      this.setFieldValue(event.target.name, event.target.value)
    },

    // Seed values from the rendered defaults so conditions match before any change event
    setFormRef(form) {
      if (form) {
        for (const [name, value] of new FormData(form)) {
          this.setFieldValue(name, value)
        }
      }
    },

    setCaptchaRef(element) {
      this.captchaRef = element
    },

    setSubmissionResponse(resp) {
      this.response = {
        ...(resp || {}),
        success: !!resp?.success,
        errors: this.normalizeErrors(resp?.errors)
      }
    },

    onSubmit(event) {
      this.formData = new FormData(event.target);
      const url = '/actions/' + this.formData.get('action');

      if (this.formData && this.token.value) {
        this.submitting = true

        fetch(url, {
          method: 'POST',
          headers: {
            'Accept': 'application/json, text-plain',
          },
          body: this.formData
        })
          .then(async (resp) => {
            const parsed = await resp.json().catch(() => null)

            if (!parsed) {
              throw new Error('Invalid JSON response')
            }

            return parsed
          })
          .then((resp) => {
            if (resp['success'] && resp.redirect) {
              window.location = resp.redirect
            } else {
              this.setSubmissionResponse(resp)
              window.scrollTo({ top: 0, behavior: 'smooth' });

              this.$nextTick(() => {
                let inputErrorTips = document.querySelectorAll('.input-error-tip');
                inputErrorTips.forEach(element => {
                  // Guard against tippy being initialized multiple times
                  if (element && element.hasOwnProperty('_tippy')) {
                    return;
                  }

                  if (element) {
                    tippy(element, {
                      content(reference) {
                        return reference.getAttribute('aria-label');
                      },
                      // offset: [0, 5],
                      // placement: 'bottom-start',
                    })
                  }
                });
              })
            }
          })
          .catch(() => {
            this.setSubmissionResponse({
              success: false,
              errors: {
                form: ['Unable to submit your request. Please try again.']
              }
            })

            window.scrollTo({ top: 0, behavior: 'smooth' })
          })
          .finally(() => {
            if (!this.success) {
              this.resetCaptcha()
            }

            this.submitting = false
          })
      } else {
        this.setSubmissionResponse({
          success: false,
          errors: {
            captcha: ['Please complete the captcha challenge.']
          }
        })
      }
    },

    onExpired() {
      this.resetCaptcha();
    },

    resetCaptcha() {
      this.token.value = ''

      if (this.captchaRef && typeof this.captchaRef.reset === 'function') {
        this.captchaRef.reset()
      }

      // Fallback: attempt to use a local ref (keeps backward compatibility)
      if (this.$refs && this.$refs.captcha && typeof this.$refs.captcha.reset === 'function') {
        this.$refs.captcha.reset()
      }
    }
  }
}
</script>
